import React from "react";
import { FormOutlined } from "@ant-design/icons";
interface Props {
  children: React.ReactNode;
}
export const PageTitle = ({ children }: Props) => (
  <div className="title_area">
    <ul className="breadcrumb">
      <li>
        <h1>
          {/* <i className="far fa-edit"></i> */}
          <FormOutlined />
          {children}
        </h1>
      </li>
    </ul>
  </div>
);
